<div class="edit-scaffold-modal">
    <hub-modal-form-header [title]="context.editMode ? 'Edit Scaffold' : 'Add Scaffold'"
        (close)="bsModalRef.hide()"></hub-modal-form-header>
    <hub-multi-step [steps]="steps" [context]="context"></hub-multi-step>
</div>